import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function KnowledgeBaseToggle() {
  const { t } = useTranslation();
  const useKnowledgeBase = SettingsStore(state => state.useKnowledgeBase);
  const setUseKnowledgeBase = SettingsStore(state => state.setUseKnowledgeBase);
  const isLoading = SettingsStore(state => state.isLoading);

  return (
    <ControlWrapper>
      <div className="flex items-center justify-between">
        <Label htmlFor="use-knowledge-base">
          {t("settings.useKnowledgeBase")}
        </Label>
        <Switch
          id="use-knowledge-base"
          checked={useKnowledgeBase}
          onCheckedChange={setUseKnowledgeBase}
          disabled={isLoading}
        />
      </div>
    </ControlWrapper>
  );
}

